import { MCMInputToolLink } from "@constants/index";

export const noop = (): void => void 0;

export const truncateString = (input: string, maxLength: number): string => {
    if (input.length > maxLength) {
        return input.substring(0, maxLength) + "...";
    } else {
        return input;
    }
};

export const isNullOrEmpty = (value: string | number): boolean => {
    return value === null || value === undefined || value === "";
};

export function measureLatency(startTime: number): number {
    const latency = Date.now() - startTime;
    return latency;
}

// Debounce function that delays invoking a function until after
// wait milliseconds have elapsed since the last time it was invoked
export function debounce<T extends (...args: Array<any>) => any>(func: T, wait: number): (...args: Parameters<T>) => void {
    let timeoutId: ReturnType<typeof setTimeout>;

    return function (...args: Parameters<T>): void {
        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, wait);
    };
}
export enum Stage {
    PROD = "prod",
    GAMMA = "gamma",
    BETA = "beta",
    ALPHA = "alpha",
}

/**
 * Function to retrieve MCM Allocation link based on stage
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getMCMInputToolLink = (stage): string => {
    if (stage === Stage.PROD) {
        return MCMInputToolLink.PROD_MCM_INPUT_TOOL_LINK;
    }
    return MCMInputToolLink.GAMMA_MCM_INPUT_TOOL_LINK;
};
